<template>
  <div class="login-page">
    <div class="login-container">
      <h1 class="login-title" style="font-size: 22px;">
        <img src="@/assets/weather-icon_128.png" alt="logo" style="width:30px;margin-right: 10px;">
        Weather Admin
      </h1>
      <el-form ref="form" :model="user" label-width="80px">
        <!-- 用户名 -->
        <el-input
          class="username-input"
          prefix-icon="el-icon-user"
          size="small"
          placeholder="请输入用户名"
          v-model="user.name"
        ></el-input>
        <!-- 密码 -->
        <el-input
          class="password-input"
          size="small"
          prefix-icon="el-icon-view"
          placeholder="请输入密码"
          v-model="user.password"
          type="password"
        ></el-input>
      </el-form>
      <!-- 按钮 -->
      <el-button class="login-button" @click="userLogin" type="primary" size="small">登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  data() {
    return {
      user: {
        name: "",
        password: ""
      }
    };
  },
  mounted() {
    window.addEventListener("keydown", this.regKeyDown);
  },
  destroyed() {
    window.removeEventListener("keydown", this.regKeyDown);
  },
  methods: {
    userLogin() {
      if (!this.user.name) {
        this.$message.error("用户名未填写");
        return;
      }

      if (!this.user.password) {
        this.$message.erorr("密码未填写");
        return;
      }

      this.$emit("login", this.user);
    },
    regKeyDown(e) {
      if (e.keyCode === 13) {
        this.userLogin();
      }
    }
  }
};
</script>

<style lang="less">
.login-page {
  display: flex;
  justify-content: center;
  .login-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .login-container {
    padding-top: 20vh;
    width: 240px;
  }
  .username-input,
  .password-input {
    margin-bottom: 20px;
  }
  .login-button {
    width: 100%;
  }
}
</style>